var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2267 11.9713L13.2708 21.9272C12.0512 23.1468 10.3969 23.832 8.67207 23.832C6.94721 23.832 5.29299 23.1468 4.07332 21.9272C2.85366 20.7075 2.16846 19.0533 2.16846 17.3284C2.16846 15.6035 2.85366 13.9493 4.07332 12.7296L14.0292 2.77382C14.8423 1.96071 15.9451 1.50391 17.095 1.50391C18.2449 1.50391 19.3477 1.96071 20.1608 2.77382C20.9739 3.58693 21.4307 4.68974 21.4307 5.83965C21.4307 6.98956 20.9739 8.09237 20.1608 8.90548L10.1942 18.8613C9.7876 19.2679 9.23619 19.4963 8.66124 19.4963C8.08628 19.4963 7.53488 19.2679 7.12832 18.8613C6.72177 18.4548 6.49337 17.9034 6.49337 17.3284C6.49337 16.7534 6.72177 16.202 7.12832 15.7955L16.3258 6.60882",
    stroke: "#7F7F7F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.2b996e4f8b5b6635e9c1373cc5211823.svg";
export { ForwardRef as ReactComponent };